var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "border-indigo-600 border rounded-xl h-5 w-9 flex items-center px-0.5 cursor-pointer transition duration-500",
    class: {
      'border-opacity-25 bg-indigo-600 justify-end': _vm.mutableValue,
      'bg-white justify-start': !_vm.mutableValue
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.checkThat.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "rounded-full h-3 w-3",
    class: {
      'bg-white': _vm.mutableValue,
      'bg-indigo-600': !_vm.mutableValue
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }